import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3c260ee7"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "flex_zone" };
const _hoisted_2 = { class: "line" };
const _hoisted_3 = { class: "currency" };
const _hoisted_4 = { class: "balance" };
import NumberText from '@/materials/atoms/NumberText.vue';
import { useStore } from '@/store/store';
import { decimalize } from '@/logics/utils';
import { ref, watchEffect } from 'vue';
import Select from '@/materials/atoms/Select.vue';
import { useMessage } from '@/const/messages';
export default /*#__PURE__*/ _defineComponent({
    props: {
        step: null,
        symbol: null,
        mode: null,
        isSell: { type: Boolean }
    },
    emits: ["selectionChange", "update:reference"],
    setup(__props, { emit }) {
        const props = __props;
        const store = useStore();
        const { format, ORDER } = useMessage();
        const setSymbol = () => {
            const item = store.state.balances.find((b) => b.symbol === props.symbol);
            const balance = item === null || item === void 0 ? void 0 : item.balance;
            const onHold = item === null || item === void 0 ? void 0 : item.onHold;
            if (!balance || onHold === null || onHold === undefined) {
                return '---';
            }
            const available = Number(balance) - Number(onHold);
            return decimalize(available, props.symbol, store.state.currencyInfo);
        };
        const options = ref();
        watchEffect(() => {
            options.value = [
                {
                    title: format(ORDER.AMOUNT),
                    value: 'Amount',
                },
            ];
            if (!props.isSell) {
                const add = [
                    ...options.value,
                    {
                        title: format(ORDER.PRICE),
                        value: 'Price',
                    },
                ];
                options.value = add;
            }
        });
        const onSelectionChange = (value) => {
            emit('selectionChange', value);
        };
        const isSmartPhone = window.innerWidth <= 960;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    (_openBlock(), _createBlock(Select, {
                        key: props.mode,
                        class: "market_mode",
                        selectionList: options.value,
                        model: props.mode,
                        height: isSmartPhone ? 33 : 22,
                        width: 75,
                        onChange: onSelectionChange
                    }, null, 8, ["selectionList", "model", "height"])),
                    _createVNode(NumberText, {
                        step: props.step,
                        mode: props.mode,
                        height: isSmartPhone ? 33 : 22,
                        fontSize: 13,
                        plusMinus: isSmartPhone
                    }, null, 8, ["step", "mode", "height"]),
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("label", null, _toDisplayString(props.symbol), 1)
                    ])
                ]),
                _createElementVNode("div", _hoisted_4, _toDisplayString(setSymbol()), 1)
            ]));
        };
    }
});
